export function generateInvoiceNumber(
  documentType = "invoice"
) {

  const date = new Date();

  const year = date.getFullYear();

  const month = String(
    date.getMonth() + 1
  ).padStart(2, "0");

  /* ---------- PREFIX ---------- */

  let typePrefix = "INV";

  if (documentType === "performa") {
    typePrefix = "PRI";
  }

  if (documentType === "receipt") {
    typePrefix = "REC";
  }

  /* ---------- MONTHLY COUNTER ---------- */

  const counterKey =
    `${typePrefix}_${year}${month}`;

  let counter =
    Number(
      localStorage.getItem(counterKey) || 0
    ) + 1;

  localStorage.setItem(
    counterKey,
    counter
  );

  /* ---------- FORMAT ---------- */

  return `SPN-${typePrefix}-${year}${month}${String(
    counter
  ).padStart(3, "0")}`;
}